import EditDataIngestionPermissionsModal from './EditDataIngestionPermissionsModal.Container';

export default EditDataIngestionPermissionsModal;
